// Legenda k heat mapám ve skupinových produktech.
//
// variant 'diverging' — odchylka od normálu (GroupPeriodGrid): modrá (pod) … bílá (v normálu) …
//   červená (nad). Krajní popisky podle `mode` ('diff' = ± v jednotce, 'pct' = ± %).
// variant 'sequential' — počet (GroupJevyOverviewGrid): 0 … max, bílá → modrá.
//
// Barvy MUSÍ odpovídat výpočtu v příslušném gridu (diffBg / countBg).

function divergingStops() {
  // t od -1 do 1, alpha = |t| * 0.5 (viz diffBg)
  return [-1, -0.5, 0, 0.5, 1].map(t => {
    if (Math.abs(t) < 0.08) return { t, css: '#ffffff' }
    const a = (Math.abs(t) * 0.5).toFixed(2)
    return { t, css: t > 0 ? `rgba(220,38,38,${a})` : `rgba(37,99,235,${a})` }
  })
}

function sequentialStops() {
  // n/max od 0 do 1, alpha = 0.12 + t*0.55 (viz countBg)
  return [0, 0.25, 0.5, 0.75, 1].map(t => ({
    t,
    css: t === 0 ? '#ffffff' : `rgba(37,99,235,${(0.12 + t * 0.55).toFixed(2)})`,
  }))
}

export function HeatLegend({ variant, mode, unit, maxCount }) {
  if (variant === 'sequential') {
    const stops = sequentialStops()
    return (
      <div className="shrink-0 flex flex-col gap-1">
        <div className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide">Dny s jevem</div>
        <div className="flex items-center gap-0">
          {stops.map(s => (
            <span key={s.t} className="w-6 h-4 border border-gray-200" style={{ backgroundColor: s.css }} />
          ))}
        </div>
        <div className="flex justify-between text-[10px] text-gray-500 tabular-nums" style={{ width: `${stops.length * 1.5}rem` }}>
          <span>0</span>
          <span>{maxCount != null && maxCount > 0 ? maxCount : 'max'}</span>
        </div>
      </div>
    )
  }

  const stops = divergingStops()
  const span = mode === 'pct' ? '30 %' : `${unit === '°C' ? '3 °C' : `3 ${unit ?? ''}`.trim()}`
  return (
    <div className="shrink-0 flex flex-col gap-1">
      <div className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide">Odchylka od normálu</div>
      <div className="flex items-center gap-0">
        {stops.map(s => (
          <span key={s.t} className="w-6 h-4 border border-gray-200" style={{ backgroundColor: s.css }} />
        ))}
      </div>
      <div className="flex justify-between text-[10px] text-gray-500" style={{ width: `${stops.length * 1.5}rem` }}>
        <span>−{span}</span>
        <span>0</span>
        <span>+{span}</span>
      </div>
    </div>
  )
}
